import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-times-interval-dropdown-picker',
  templateUrl: './times-interval-dropdown-picker.component.html',
  styleUrls: ['./times-interval-dropdown-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimesIntervalDropdownPickerComponent implements OnInit {

  @Input() fromLabel = 'From:';
  @Input() toLabel = 'To:';
  @Input() zIndex = 1;

  @Input() fromControlKey = 'openingTime';
  @Input() toControlKey = 'closingTime';

  overlayListZIndex: number | undefined;

  @Input() form: FormGroup;

  timesFromListData: { value: string, label?: string }[];
  timesToListData: { value: string, label?: string }[];

  ngOnInit(): void {

    this.overlayListZIndex = this.zIndex + 1;

    const timeList = [];
    for (let hour = 5; hour < 24; hour++) {
      const ampm = hour < 12 ? 'AM' : 'PM';
      const hour12 = hour > 12 ? hour - 12 : hour;
      const timeString = `${hour12}:00 ${ampm}`;
      timeList.push({value:timeString});
    }
    
    this.timesFromListData = [{ value: null, label: 'Select time' }, ...timeList];
    this.timesToListData = [{ value: null, label: 'Select time' }, ...timeList];
  }
}
